import React from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";

const HeroSection = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Box
        sx={{
          position: "relative",
          height: isSmallScreen ? "150px" : "300px",
          overflow: "hidden",
          "& img": {
            width: "100%",
            height: "100%",
            objectFit: "cover",
          },
        }}
      >
        <Box
          sx={{
            position: "relative",
            height: "100%",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              zIndex: 1,
            },
            "& img": {
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: 0,
            },
          }}
        >
          <img src="/static/img/illustrations/Medical-Team-3.jpg" alt="OnRounds PRO Pricing" />
        </Box>
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: "#FFFFFF; text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3)",
            textAlign: "center",
            p: 5,
            zIndex: 1,
          }}
        >
          <Typography
            variant="h1"
            component="h1"
            gutterBottom
            sx={{ fontSize: { xs: "1rem", sm: "2rem", md: "3rem" }, marginBottom: "5px" }}
          >
            OnRounds AI Pricing
          </Typography>
          <Typography variant="subtitle1" sx={{ fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" } }}>
            Elevate healthcare delivery and streamline EHR/EMR documentation - <b>saving you time</b>.
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default HeroSection;
